interface Photo {
  id: number
  img: string
}

export const photos: Photo[] = [
  {
    id: 1,
    img: './assets/photo1.jpg'
  },
  {
    id: 2,
    img: './assets/photo2.jpg'
  },
  {
    id: 3,
    img: './assets/photo3.jpg'
  },
  {
    id: 4,
    img: './assets/photo4.jpg'
  },
  {
    id: 5,
    img: './assets/photo5.jpg'
  }
]
